module.exports = __webpack_public_path__ + "img/medal.8f7114cc.webp";